import React from "react";
import { Toaster } from "sonner";

/**
 * Enhanced Sonner Toast Manager
 * Provides better positioning, custom styling, and enhanced features
 * Shows toasts one by one from top to bottom in a queue
 */
const SonnerToastManager = () => {
  return (
    <Toaster
      position="top-center"
      richColors
      duration={3000}
      closeButton
      visibleToasts={1}
      expand={false}
      gap={12}
      toastOptions={{
        className: "toast-enhanced",
        style: {
          borderRadius: "12px",
          padding: "16px",
          boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          marginBottom: "12px",
        },
      }}
      // Custom styling for different toast types
      style={{
        "--toast-success-bg": "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        "--toast-error-bg": "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
        "--toast-warning-bg": "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
        "--toast-info-bg": "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
      }}
    />
  );
};

export default SonnerToastManager;
